import React, { useEffect, useState } from "react";
import WrapperPropertiesCard from "./cards/WrapperPropertiesCard";
import { DateTime } from "luxon";
import MapPin from "../../../../icons/MapPin";
import { useCountdownV2 } from "services";
interface UpcomingEventsContainerProps {
  setOpen: any;
  setSelected: any;
  upcomingAuction: any;
}
export default function UpcomingEventsContainer({
  setOpen,
  setSelected,
  upcomingAuction,
}: UpcomingEventsContainerProps) {
  const [endTime, setEndTime] = useState<any>(0);
  const [timeOffset, setTimeOffset] = useState(0);
  const [serverTime, setServerTime] = useState(0);

  useEffect(() => {
    const calculateEndTimeAndTimeOffset = () => {
      setServerTime(upcomingAuction?.[0]?.server_time);
      setEndTime(upcomingAuction?.[0]?.start_date_time);
    };
    calculateEndTimeAndTimeOffset();
  }, [upcomingAuction]);

  useEffect(() => {
    if (serverTime) {
      const serverDateTime =
        DateTime.fromMillis(serverTime).setZone("Asia/Kolkata");
      const localDateTime = DateTime.now().setZone("Asia/Kolkata");
      const offset = serverDateTime.toMillis() - localDateTime.toMillis();
      setTimeOffset(offset);
    }
  }, [serverTime]);
  const viewDetailsClickHandler = (propertyData: any) => {
    setSelected({
      ...propertyData.property,
      images: [
        {
          uuid:
            propertyData?.property_dump?.images?.length > 0
              ? propertyData?.property_dump?.images?.[0]?.uuid
              : propertyData?.property_dump?.sub_asset_type_images?.length > 0
              ? propertyData?.property_dump?.sub_asset_type_images?.[0]?.uuid
              : process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
              ? "27f785cc-24cb-4531-9b91-4a6c58bfaf37"
              : "771263b2-a630-46f2-ae99-24cece88c4be",
        },
      ],
      listing_id: propertyData.property.listing_id,
      property_date_type: propertyData.property.property_date_type,
      bank: propertyData.bank,
      reserve_price: propertyData.reserve_price,
      asset: propertyData.property_dump.asset,
      sub_asset_type: propertyData.property_dump.sub_asset_type,
      city: propertyData.property_dump.city,
      state: propertyData.property_dump.state,
      start_date_time: propertyData.start_date_time,
    });
    setOpen(true);
  };
  const [progress, setProgress] = useState<any>(0);

  useEffect(() => {
    if (endTime && serverTime) {
      const startDateTime = DateTime.fromISO(endTime).setZone("Asia/Kolkata");
      const serverDateTime =
        DateTime.fromMillis(serverTime).setZone("Asia/Kolkata");
      const localDateTime = DateTime.now().setZone("Asia/Kolkata");
      const offset = serverDateTime.toMillis() - localDateTime.toMillis();
      const currentTime = DateTime.now()
        .plus({ milliseconds: offset })
        .setZone("Asia/Kolkata");

      const totalDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
      const timeLeft = Math.max(
        startDateTime.toMillis() - currentTime.toMillis(),
        0
      );

      const progressValue = ((totalDuration - timeLeft) / totalDuration) * 100;
      setProgress(Math.min(Math.max(progressValue, 0), 100)); // Ensure it stays between 0-100
    }
  }, [endTime, serverTime]);

  const [hours, minutes, seconds, isTimeEnded] = useCountdownV2(
    endTime,
    timeOffset
  );

  return (
    <WrapperPropertiesCard
      cardType="auction"
      showTag={true}
      tagText={
        upcomingAuction && upcomingAuction?.[0]?.status === "live"
          ? "LIVE AUCTION"
          : "Auction starting soon"
      }
      showId={true}
      id={upcomingAuction?.[0]?.listing_id}
      imgLink="https://auction-bazaar-production.imgix.net/d641c24c-d728-43c8-ba0f-9e1e30133f06"
      headingText={`${upcomingAuction?.[0]?.property_dump?.asset?.name} ${upcomingAuction?.[0]?.property_dump?.sub_asset_type?.name}`}
      subHeadingText={`${upcomingAuction?.[0]?.property_dump?.city?.name}, ${upcomingAuction?.[0]?.property_dump?.state?.name}`}
      showCTA={true}
      ctaText={
        upcomingAuction && upcomingAuction?.[0]?.status === "live"
          ? "Start Bidding"
          : "View details"
      }
      status={upcomingAuction?.[0]?.status}
      progressValue={parseInt(progress)}
      onclickHandler={() => {
        viewDetailsClickHandler(upcomingAuction?.[0]);
      }}
      subHeadingIcon={<MapPin />}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
      styles={{
        tagStyle: "bg-[#FEECE6] text-[#FF752C]",
        CTAStyle: "bg-black text-white font-sans",
        imgStyle:
          "w-full object-cover max-h-[260px] h-[180px] xl:h-[240px] min-w-[200px] xl:min-w-[260px]",
      }}
    />
  );
}
